import React from 'react';

const NgProblemSection = () => {
  const painPoints = [
    'Most never come back.',
    'Your WhatsApp and SMS blasts feel like spam.',
    'Ad spend keeps rising while ROI keeps falling.',
    'You’re too busy running the business to become a full-time marketer.',
  ];

  return (
    <section id="problem" className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-8">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-black/70 mb-3">
            The Problem
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-4">
            You close sales every single day.<br />
            <span className="bg-gradient-to-r from-[#8ae690] to-[#7ad67f] bg-clip-text text-transparent">
              But your POS data is just sitting there.
            </span>
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            Your POS has the names, purchase history, and exact spending habits of thousands of customers.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.15fr_0.85fr] items-stretch">
          <div className="rounded-[2rem] border border-gray-200 bg-gradient-to-br from-white via-gray-50 to-white p-5 sm:p-7 shadow-[0_24px_60px_-24px_rgba(0,0,0,0.14)]">
            <div className="flex flex-wrap items-center gap-3 mb-5">
              <span className="inline-flex items-center rounded-full bg-[#8ae690]/20 px-3 py-1 text-xs font-semibold text-black">
                Customer data available
              </span>
              <span className="inline-flex items-center rounded-full bg-red-50 px-3 py-1 text-xs font-semibold text-red-700">
                Revenue leaking daily
              </span>
            </div>

            <div className="grid gap-3 sm:grid-cols-2">
              {painPoints.map((point, index) => (
                <div
                  key={point}
                  className="rounded-2xl border border-gray-200 bg-white/90 px-4 py-4"
                >
                  <div className="flex items-start gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-black text-xs font-bold text-white shrink-0">
                      0{index + 1}
                    </div>
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                      {point}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-5 rounded-2xl border border-[#8ae690]/40 bg-[#8ae690]/10 px-4 py-4">
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                You know the data is pure gold. But turning it into repeat sales feels impossible without a team,
                a budget, or hours you don’t have.
              </p>
            </div>
          </div>

          <div className="relative rounded-[2rem] border border-gray-200 bg-black text-white p-5 sm:p-7 overflow-hidden shadow-[0_24px_60px_-24px_rgba(0,0,0,0.35)]">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(138,230,144,0.22),transparent_38%)]" />
            <div className="relative">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/70 mb-4">
                What competitors are doing
              </p>

              <div className="space-y-4 mb-6">
                <div className="rounded-2xl bg-white/10 border border-white/10 px-4 py-4">
                  <p className="text-sm text-white/80 mb-1">Their advantage</p>
                  <p className="text-lg font-semibold text-white">
                    Personalized offers sent at the right moment
                  </p>
                </div>
                <div className="rounded-2xl bg-white/10 border border-white/10 px-4 py-4">
                  <p className="text-sm text-white/80 mb-1">Your reality</p>
                  <p className="text-lg font-semibold text-white">
                    Generic blasts that feel easy to ignore
                  </p>
                </div>
              </div>

              <p className="text-sm sm:text-base text-white/85 leading-relaxed">
                Meanwhile, your competitors are quietly stealing your customers with personalized offers you wish you
                had time to create.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NgProblemSection;

